import {useHasScope} from "../../../../../config/globalConfig";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";
import {SCOPE_CS_FINANCE_VIEW, VIEW_RECEIVABLE} from "../../../utils/FinanceScope";
import InvoicesFilter from "../filters/InvoicesFilter";
import InvoicesTable from "../tables/InvoicesTable";
import {Box, Stack, Tab, Tabs} from "@mui/material";
import {useState} from "react";
import {useTranslation} from "react-i18next";

function Invoices() {
    const { t } = useTranslation("finance", { keyPrefix: "invoices" });

    const hasScope = useHasScope;
    const [tab, setTab] = useState<'planet' | 'carsharing'>('planet');

    if (!hasScope(VIEW_RECEIVABLE)) {
        return <NotAuthorizedDialog/>;
    }

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue === 0 ? 'planet' : 'carsharing');
    };

    return (
        <Stack direction="column" spacing={2} margin="16px">
            <InvoicesFilter currentTab={tab}/>

            <Box>
                <Tabs value={tab === 'planet' ? 0 : 1}
                      onChange={handleChange}>
                    <Tab label={t("planetInvoices")}/>
                    {hasScope(SCOPE_CS_FINANCE_VIEW) && <Tab label={t("carSharingInvoice")}/>}
                </Tabs>
            </Box>

            <Box>
                {tab === 'planet' && <InvoicesTable/>}
                {hasScope(SCOPE_CS_FINANCE_VIEW) && (tab === 'carsharing' && <InvoicesTable carsharing={true}/>)}
            </Box>
        </Stack>
    );
}

export default Invoices;